import { Component, OnInit, ViewChild } from '@angular/core';
import { AusenciaTemporaria } from 'src/app/_models/AusenciaTemporariaModel';
import { AusenciaTemporariaService } from 'src/app/_services/ausenciaTemporaria.service';
import { User, Responsavel, Message } from 'src/app/_models';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { UsuariosResponsaveisService } from 'src/app/_services';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import moment from 'moment';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
    selector: 'app-ausencia-temporaria',
    templateUrl: './ausencia-temporaria.component.html',
    styleUrls: ['./ausencia-temporaria.component.css']
})
export class AusenciaTemporariaComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    currentUser: User;
    frmAusencia: FormGroup;

    cadastroAusencia = new AusenciaTemporaria();

    public listaAusencias: AusenciaTemporaria[];
    public responsaveis: Responsavel[];
    public novosResponsaveis: Responsavel[];
    filteredUsers: Observable<Responsavel[]>;
    listaResponsaveis: Observable<Responsavel[]>;

    // Screen rules
    usersLoading = false;
    delegarPerfil = false;
    messageModel: Message;

    TipoFiltro = {
        Responsavel: 1,
        NovoResponsavel: 2
    };

    movimentarProtocoloTerceiros = {} as boolean;

    displayedColumns: string[] = ['loginUsuario', 'loginUsuarioRecebedor', 'dataInicio', 'dataFim', 'delegarPerfil', 'ativo', 'actions'];
    dataSource = new MatTableDataSource<AusenciaTemporaria>();
    selection = new SelectionModel<AusenciaTemporaria>(true, []);

    optionsResponsavel = [] as string[];
    filteredOptionsResponsavel: Observable<string[]>;
    filteredResponsavel: any;
    frmFiltroResponsavel = new FormControl();
    responsavel = {} as Responsavel;
    novoResponsavel = {} as Responsavel;

    optionsNovoResponsavel = [] as string[];
    filteredOptionsNovoResponsavel: Observable<string[]>;
    filteredNovoResponsavel: any;
    frmFiltroUser = new FormControl();
    bloquearResponsavel = {} as boolean;

    constructor(
        private loadComponent: AppComponent,
        private formBuilder: FormBuilder,
        private ausenciaTemporariaService: AusenciaTemporariaService,
        private responsaveisService: UsuariosResponsaveisService,
        private dialog?: MatDialog,
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

    ngOnInit() {

        this.CarregarValidacoesTela();
        this.obterAusenciasCadastradas();
        this.obterResponsaveis();
        this.bloquearResponsavel = !this.currentUser.movimentarProtocoloTerceiros;
    }

    get f() { return this.frmAusencia.controls; }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    onChangeDelegarPerfil() {
        this.delegarPerfil = !this.delegarPerfil;
    }

    CarregarValidacoesTela() {
        this.frmAusencia = this.formBuilder.group({
            frmDtInicial: ['', Validators.required],
            frmDtFinal: ['', Validators.required],
            frmDelegarPerfil: [''],
            frmFiltroUser: ['', Validators.required],
            frmFiltroResponsavel: ['', Validators.required]
        });
    }

    obterAusenciasCadastradas() {
        this.ausenciaTemporariaService.listarAusenciasCadastradas()
            .subscribe(result => {
                this.listaAusencias = result.data;
                this.dataSource = new MatTableDataSource<AusenciaTemporaria>(this.listaAusencias);
                this.dataSource.paginator = this.paginator;
            });
    }

    obterResponsaveis() {
        this.usersLoading = true;
        this.responsaveisService.getResponsaveisAtivos()
            .subscribe(data => {
                this.responsaveis = data.data as Responsavel[];
                this.novosResponsaveis = data.data as Responsavel[];
            }, erro => {
                console.log(`Ocorreu um erro ao recuperar a lista de responsáveis. Erro: ${erro}`);
            },
                () => {
                    this.novosResponsaveis = this.novosResponsaveis.filter(p => p.login !== this.currentUser.login) || [];
                    this.usersLoading = false;

                    this.optionsResponsavel = this.responsaveis.map(({ nome }) => nome);
                    this.filteredResponsavel = this.optionsResponsavel.slice();
                    this.filteredOptionsResponsavel = this.frmFiltroResponsavel.valueChanges
                        .pipe(
                            startWith(''),
                            map(value => this._filterResponsavel(value))
                        );

                    this.optionsNovoResponsavel = this.novosResponsaveis.map(({ nome }) => nome);
                    this.filteredNovoResponsavel = this.optionsNovoResponsavel.slice();
                    this.filteredOptionsNovoResponsavel = this.frmFiltroUser.valueChanges
                        .pipe(
                            startWith(''),
                            map(value => this._filterNovoResponsavel(value))
                        );
                }).add(() => {
                    if (this.responsaveis.length > 0) {
                        this.responsavel = this.responsaveis.filter(p => p.login === this.currentUser.login)[0];
                        this.frmAusencia.controls['frmFiltroResponsavel'].setValue(this.responsavel.nome);
                    }
                    this.usersLoading = false;
                });
    }

    excluir(ausencia: any) {
        let msg: string;

        if (ausencia.ativo) {
            msg = `Esse cadastro de ausência temporária está ativo. Se você excluir esse cadastro, todos os protocolos que foram alterados
            na data de início serão terão o responsável novamente alterado para o responsável inicial. Confirma a exclusão?`;
        } else {
            msg = 'Confirmar a exclusão?';
        }

        this.messageModel = new Message('Atenção', msg, '', 'confirm');
        const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        let confirm = false;
        dialogRef.afterClosed().subscribe(result => {
            confirm = result;
            if (confirm) {
                this.ausenciaTemporariaService.excluirAusenciaTemporaria(ausencia.id)
                    .subscribe(data => {
                        this.messageModel = new Message('Êxito', 'Cadastro excluido com sucesso', '', '');
                        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
                        this.obterAusenciasCadastradas();
                    });
            }
        });
    }

    cadastrarAusencia() {
        this.loadComponent.startLoading(true);
        const userResponsavel: Responsavel = this.novosResponsaveis.find(p => p.nome === this.novoResponsavel.nome);
        const responsavel: Responsavel = this.responsaveis.find(p => p.nome === this.responsavel.nome);
        this.cadastroAusencia.delegarPerfil = this.delegarPerfil;
        this.cadastroAusencia.loginUsuario = responsavel.login;
        this.cadastroAusencia.nomeUsuario = responsavel.nome;
        this.cadastroAusencia.loginUsuarioRecebedor = userResponsavel.login;
        this.cadastroAusencia.emailUsuarioRecebedor = userResponsavel.email;
        this.cadastroAusencia.nomeUsuarioRecebedor = userResponsavel.nome;

        this.ausenciaTemporariaService.cadastrarAusenciaTemporaria(this.cadastroAusencia)
            .subscribe(data => {
                const result = data.data;
                let msg = '';
                if (result.success) {
                    msg = 'Ausência temporária cadastrada com sucesso.';
                    this.messageModel = new Message('Êxito', msg, '', '');

                    this.obterAusenciasCadastradas();
                    this.limparCampos();
                } else {
                    this.messageModel = new Message('Atenção', result.message, '', '');
                }

                this.dialog.open(PopupMessagesNewStyleTestComponent, {
                    data: this.messageModel
                });

            }).add(() => this.loadComponent.startLoading(false));
    }

    limparCampos() {
        this.frmAusencia.controls['frmDtInicial'].setValue('');
        this.frmAusencia.controls['frmDtFinal'].setValue('');
        this.delegarPerfil = false;
        this.frmAusencia.controls['frmFiltroUser'].setValue('');
        this.novoResponsavel = {} as Responsavel;
    }

    filterDataInicio = (d: Date): boolean => {
        return d > new Date();
    }

    filterDataFim = (d: Date): boolean => {
        const valid = d >= this.cadastroAusencia.dataInicio;

        return valid;
    }

    desabilitarExclusao(ausencia: AusenciaTemporaria) {
        const dataAtual = moment(new Date());
        const dataFim = moment(ausencia.dataFim);
        if (dataFim >= dataAtual) {
            return false;
        } else {
            return true;
        }
    }

    private _filterResponsavel(event: any): string[] {
        const filterValue = event.toLowerCase();
        return this.optionsResponsavel.filter(option => option.toLowerCase().includes(filterValue));
    }

    private _filterNovoResponsavel(event: any): string[] {
        const filterValue = event.toLowerCase();
        return this.optionsNovoResponsavel.filter(option => option.toLowerCase().includes(filterValue));
    }

    formularioIsValid() {
        this.cadastroAusencia.dataInicio = this.cadastroAusencia.dataInicio || null;
        this.cadastroAusencia.dataFim = this.cadastroAusencia.dataFim || null;
        this.novoResponsavel.nome = this.novoResponsavel.nome || null;

        if (this.cadastroAusencia.dataInicio === null) {
            return true;
        }
        if (this.cadastroAusencia.dataFim === null) {
            return true;
        }
        if (this.novoResponsavel.nome === null) {
            return true;
        }

        return false;
    }
}
